module.exports = __webpack_public_path__ + "img/chipsc.1737d87b.png";